module.exports = __webpack_public_path__ + "0c984578e9d558ded9d61e0b8e0a9128.MP3";